import { render, staticRenderFns } from "./ServiceRequests.vue?vue&type=template&id=581bb4f6&"
import script from "./ServiceRequests.vue?vue&type=script&lang=js&"
export * from "./ServiceRequests.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequests.vue?vue&type=style&index=0&id=581bb4f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports